import { Tabs } from '@bedrock/components';
import './index.less';

export default Tabs;
